import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { AlertService } from 'src/app/services/alert.service';
import { UtilityService } from 'src/app/services/utility.service';
// import { FileviewerComponent } from '../../modal-popup/fileviewer/fileviewer.component';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { VehicleService } from 'src/app/services/vehicle.service';
import { DriverService } from 'src/app/services/driver.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-returnattachment',
  templateUrl: './returnattachment.component.html',
  styleUrls: ['./returnattachment.component.scss']
})
export class ReturnAttachmentComponent implements OnInit {
  form: FormGroup;
  selectedFileName = 'Choose File';
  filesResult: any;
  uploadData: any[];
  submitBtnTxt = "Add";
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  attachmentName: any;
  fileType: number;
  imgerr: boolean;
  accesstype: boolean;
  acceptsize: number;
  constructor(
    public dialogRef: MatDialogRef<ReturnAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    public dialog: MatDialog
  ) {
    this.uploadData = [];
  }

  ngOnInit() {
    this.initializeValidators();
  }



  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [0],
      userPhotoPath: [null, Validators.required],
      insuranceAttachment: [],
      userPhoto: [],
      fileSize: []
    });
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }





  close(isProceed) {
    this.dialogRef.close(isProceed);
  }

  onFileSelected(event1) {
    const file = event1.target.files[0];
    let ext = file.name.split('.').pop();
    if (this.form.value.attachmentType_Id == 2 || this.form.value.attachmentType_Id == 1) {
      this.accesstype = file && file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
    } else {
      this.accesstype = file && file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || ext === 'pdf';
    }

    if (this.accesstype) {
      if (ext == 'pdf') {
        this.fileType = 2;
      } else {
        this.fileType = 1;
      }
      this.selectedFileName = file.name;
      let filesize = file.size;
      this.acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (ext != 'pdf') {
        if (this.acceptsize < 1000) {
          if (event1.target.files && event1.target.files[0]) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.filesResult = event.target.result.split(',')[1];
              if (this.filesResult) {
                this.form.controls['userPhoto'].setValue(this.filesResult);
                this.form.controls['userPhotoPath'].setValue(this.filesResult ? this.selectedFileName : ''); // <-- Set Value for Validation
                this.form.controls['fileSize'].setValue(this.acceptsize);
                this.imgerr = false;
              }
            }
          }
        } else {
          this.alertService.error('File size is large');
          this.selectedFileName = '';
        }
      }
      if (ext == 'pdf') {
        if (this.acceptsize < 5000) {
          if (event1.target.files && event1.target.files[0]) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.filesResult = event.target.result.split(',')[1];
              if (this.filesResult) {
                this.form.controls['userPhoto'].setValue(this.filesResult);
                this.form.controls['userPhotoPath'].setValue(this.filesResult ? this.selectedFileName : ''); // <-- Set Value for Validation
                this.form.controls['fileSize'].setValue(this.acceptsize);
                this.imgerr = false;
              }
            }
          }
        } else {
          this.alertService.error('File size is large');
          this.selectedFileName = '';
        }
      }


    } else {
      if (this.form.value.attachmentType_Id == 2 || this.form.value.attachmentType_Id == 1) {
        this.alertService.error('Please upload JPG & PNG images');
      } else {
        this.alertService.error('Please upload PDF, JPG & PNG images');
      }

    }
  }

  onCancel(isProceed) {
    this.dialogRef.close(isProceed);
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.filesResult) {
        const data = {
          id: 0,
          attachmentPath: "string",
          attachmentFilename: this.selectedFileName,
          attachmentTypeName: this.attachmentName,
          base64String: this.filesResult,
          statusType: 2,
          fileType: this.fileType,
          fileSize: this.form.value.fileSize,
        }
        this.dialogRef.close(data);
      } else {
        this.imgerr = true;
      }

    } else {
      this.validateFormControl();
    }
  }
}
